import React, { useState, useRef, useEffect } from 'react';
import UserProfileAvatar from 'ats/components/user-profile-avatar/UserProfileAvatar';
import { formatTimeAgo } from 'shared/utils';
import ClientInsightsForm from '../components/ClientInsightsForm';

export default function ClientInsights({ client, onSuccess }) {
	const [isEditing, setIsEditing] = useState(false);
	const [isFormSubmitting, setIsFormSubmitting] = useState(false);
	const formRef = useRef(null);

	useEffect(() => {
		if (!isEditing) {
			setIsFormSubmitting(false);
		}
	}, [isEditing]);

	return (
		<div className="client-insights">
			<div className="client-tab-section-header client-tab-section-header--insights">
				<div className="client-tab-section-title">Insights</div>
				<div className="client-tab-section-trailing">
					{!isEditing && (
						<div className="client-insights-header-meta is-flex gap-1 is-align-items-center">
							<UserProfileAvatar
								imageUrl={client?.updatedBy?.imageUrl}
								name={client?.updatedBy?.name}
							/>
							<span>
								Updated:{' '}
								{client?.updatedAt
									? formatTimeAgo(new Date(client.updatedAt))
									: null}
							</span>
						</div>
					)}
					{isEditing ? (
						<div className="client-insights-header-actions">
							<button
								type="button"
								className="cancel-btn"
								onClick={() => formRef.current?.cancelEdit()}>
								Cancel
							</button>
							<button
								type="button"
								className="save-btn"
								disabled={isFormSubmitting}
								onClick={() => formRef.current?.submit()}>
								Save
							</button>
						</div>
					) : (
						<div className="table-action-buttons">
							<button
								type="button"
								className="ats-button-soft ats-button-soft--icon-only"
								aria-label="Edit insights"
								onClick={() => setIsEditing(true)}>
								<img
									src="/ats/icons/pencil-blue-icon.svg"
									alt=""
									width={16}
									height={16}
								/>
							</button>
						</div>
					)}
				</div>
			</div>
			<div
				className={
					'client-insights-body' +
					(isEditing ? ' client-insights-body--editing' : '')
				}>
				<ClientInsightsForm
					ref={formRef}
					data={client}
					onSuccess={onSuccess}
					isEditing={isEditing}
					onIsEditingChange={setIsEditing}
					onSubmittingChange={setIsFormSubmitting}
				/>
			</div>
		</div>
	);
}
